import { useContext, useEffect, useState } from 'react'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import ApiContext from 'src/provider/API/call-service'
import { ScreenContainer, CustomContainer, AppSpan, AppText, FlexRow, GridContainer, Button, Form, AppLink, OnboardingOtpLabel, FlexColumn } from 'src/style'
import ResendIcon from 'src/assets/svg/resend-otp-icon'
import { useNavigate } from 'react-router-dom'
import { IoArrowBackOutline } from 'react-icons/io5'

export const PhoneNumberVerificationD2: React.FC<any> = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const {info} = useContext(AppInfoContext)
    const {user: {onboardingInput}} = useContext(UserContext)
    const [onboardingType, setOnboardingType] = useState(info.onboardingType)
    const [verificationCode, setVerificationCode] = useState('')

    let isRfsFlow = info.institutionData.onboardingFlow === 'RFS'

    useEffect(() => {
        if (info.onboardingType) setOnboardingType(info.onboardingType)
    }, [info.onboardingType])

    const handleCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length < 7) {
            setVerificationCode(e.target.value)
        }
    }

    function handleResend () {
        API.resendOtp(onboardingInput.bvn)
    }

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (verificationCode.length != 6) return notifier.show('Kindly provide a valid otp', 'Validation Response')

        let response;

        if (!isRfsFlow) {
            response = onboardingType === 'existing-user' ? 
                await API.getReturningCustomerData(verificationCode)
                : await API.getNewCustomerData(verificationCode)
        }
        else {
            response = onboardingType === 'existing-user' ? 
                await API.getNewCustomerData(verificationCode)
                : await API.getNonNGNewCustomerData(verificationCode)
        }
        
        if (response) {
            if (onboardingType === 'existing-user') navigate('/onboarding/info-confirmation')
            else navigate('/onboarding/user-verification')
        }
    }
    
    return (
        <ScreenContainer padding='2.5' height='auto' sizeUnit=''>
            <FlexColumn 
                justifyContent='flex-start'
                className='onboarding-screen-container-d2'
            >
                <AppText 
                    textSize='3' color='#101828'
                    bottomMargin='1.5' fontFamily='Gilmer-Bold'
                >
                    One Time Password
                </AppText>
                <AppSpan>
                    Please enter the One Time Password (OTP) sent to your {isRfsFlow ? 'Email' : 'Phone Number'} 
                    <AppSpan color='#0EA59D' fontWeight='600'> {isRfsFlow ? onboardingInput?.email : onboardingInput?.phoneNo} </AppSpan>
                </AppSpan>

                <Form onSubmit={handleSubmit}>
                    <FlexRow 
                        width="auto" sizeUnit="" 
                        topMargin='2' gap='1.4'
                        justifyContent='center'
                    >
                        <input 
                            className='display-hidden' id='code' 
                            name="verificationCode" value={verificationCode} 
                            onChange={handleCode} 
                            autoFocus={true} autoComplete="off"
                        />
                        <OnboardingOtpLabel className={`${verificationCode.length === 0 ? 'active-otp-box' : ''}`} htmlFor='code' >{verificationCode[0] ? '*' : ''}</OnboardingOtpLabel>
                        <OnboardingOtpLabel className={`${verificationCode.length === 1 ? 'active-otp-box' : ''}`} htmlFor='code' >{verificationCode[1] ? '*' : ''}</OnboardingOtpLabel>
                        <OnboardingOtpLabel className={`${verificationCode.length === 2 ? 'active-otp-box' : ''}`} htmlFor='code' >{verificationCode[2] ? '*' : ''}</OnboardingOtpLabel>
                        <OnboardingOtpLabel className={`${verificationCode.length === 3 ? 'active-otp-box' : ''}`} htmlFor='code' >{verificationCode[3] ? '*' : ''}</OnboardingOtpLabel>
                        <OnboardingOtpLabel className={`${verificationCode.length === 4 ? 'active-otp-box' : ''}`} htmlFor='code' >{verificationCode[4] ? '*' : ''}</OnboardingOtpLabel>
                        <OnboardingOtpLabel className={`${verificationCode.length >= 5 ? 'active-otp-box' : ''}`} htmlFor='code' >{verificationCode[5] ? '*' : ''}</OnboardingOtpLabel>
                    </FlexRow>

                    <GridContainer
                        bgColor='#E7F6F5' minHeight='6.2' radius='0.8'
                        shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                        padding='2' topPadding='1' bottomPadding='1'
                        topMargin='2.5'
                    >
                        <FlexRow gap='1.5' className='test-safari'>
                            <ResendIcon className='icon-component' />
                            <AppText textSize='1.2' color='#0A756F'>Did not receive OTP.
                                <AppLink textSize='1.2' color='#0A756F' fontWeight='700' hoverColor='#000000' onClick={handleResend}> Tap here to resend </AppLink> 
                            </AppText>
                        </FlexRow>
                    </GridContainer>
                    <FlexRow justifyContent='flex-end' gap='1.5' topMargin='3'>
                        <Button 
                            width='9.3' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            childHoverColor='#0D968F' type="button"
                            onClick={() => navigate(-1)}
                        >
                            <AppSpan color='#344054' rightMargin='1' textSize='1.6'>
                                <IoArrowBackOutline/>
                            </AppSpan>
                            Back
                        </Button>
                        <Button 
                            width='8.8' height='4'
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                        >
                            Proceed
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </ScreenContainer>
    )
}
